var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginleftsvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 559.93,
    height: 544.425,
    viewBox: "0 0 559.93 544.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(25.257 -112.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(15.629 113.646)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4044",
    "data-name": "Rectangle 4044",
    width: 10.824,
    height: 201.08,
    rx: 1.743,
    transform: "matrix(0.947, -0.321, 0.321, 0.947, 259.133, 351.428)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4036",
    "data-name": "Rectangle 4036",
    width: 10.824,
    height: 128.829,
    rx: 1.744,
    transform: "matrix(0.778, -0.628, 0.628, 0.778, 283.887, 331.03)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4037",
    "data-name": "Rectangle 4037",
    width: 10.824,
    height: 100.524,
    rx: 1.744,
    transform: "translate(299.8 306.415) rotate(-59.038)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4038",
    "data-name": "Rectangle 4038",
    width: 10.824,
    height: 211.458,
    rx: 1.743,
    transform: "translate(308.133 280.375) rotate(-79.198)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4039",
    "data-name": "Rectangle 4039",
    width: 165.906,
    height: 10.824,
    rx: 1.743,
    transform: "translate(310.573 242.728) rotate(-9.355)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4040",
    "data-name": "Rectangle 4040",
    width: 180.004,
    height: 10.824,
    rx: 1.744,
    transform: "translate(302.121 216.208) rotate(-29.513)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4041",
    "data-name": "Rectangle 4041",
    width: 126.207,
    height: 10.824,
    rx: 1.744,
    transform: "translate(287.763 189.606) rotate(-49.679)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4032",
    "data-name": "Rectangle 4032",
    width: 177.962,
    height: 10.825,
    rx: 1.744,
    transform: "translate(263.171 167.062) rotate(-69.843)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(229.034 45.66)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    "data-name": "Rectangle 1723",
    width: 112.822,
    height: 10.825,
    rx: 1.744,
    transform: "translate(0 112.822) rotate(-89.919)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4033",
    "data-name": "Rectangle 4033",
    width: 10.824,
    height: 143.697,
    rx: 1.743,
    transform: "matrix(0.955, -0.297, 0.297, 0.955, 157.435, 30.527)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4030",
    "data-name": "Rectangle 4030",
    width: 10.822,
    height: 179.035,
    rx: 1.743,
    transform: "matrix(0.794, -0.608, 0.608, 0.794, 66.744, 50.087)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4031",
    "data-name": "Rectangle 4031",
    width: 10.824,
    height: 108.277,
    rx: 1.743,
    transform: "translate(71.227 163.06) rotate(-57.595)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4034",
    "data-name": "Rectangle 4034",
    width: 10.824,
    height: 161.938,
    rx: 1.743,
    transform: "translate(0 214.904) rotate(-77.755)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4042",
    "data-name": "Rectangle 4042",
    width: 112.613,
    height: 10.825,
    rx: 1.743,
    transform: "matrix(0.882, -0.471, 0.471, 0.882, 62.835, 345.537)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4043",
    "data-name": "Rectangle 4043",
    width: 159.737,
    height: 10.824,
    rx: 1.743,
    transform: "matrix(0.666, -0.746, 0.746, 0.666, 67.031, 439.322)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4045",
    "data-name": "Rectangle 4045",
    width: 95.922,
    height: 10.824,
    rx: 1.744,
    transform: "translate(159.525 433.95) rotate(-68.39)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(224.938 357.247)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4027",
    "data-name": "Rectangle 4027",
    width: 50.311,
    height: 10.826,
    rx: 1.743,
    transform: "translate(0 50.295) rotate(-88.558)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(189.487 227.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M354.566-139.09a5.54,5.54,0,0,1,5.725,5.584,5.54,5.54,0,0,1-5.725,5.583,5.523,5.523,0,0,1-5.655-5.583A5.524,5.524,0,0,1,354.566-139.09ZM349.76-124.6h9.754v36.965H349.76Z",
    transform: "translate(-348.911 139.09)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M390.269-110.138c-7.28,0-9.966,4.523-9.966,11.874v16.115h-9.754v-36.965h9.542v5.371a10.753,10.753,0,0,1,10.178-6.29Z",
    transform: "translate(-355.141 133.604)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M455.008-82.149h-9.754v-22.123c0-4.382-2.191-7-5.8-7-3.534,0-6.007,2.615-6.007,7.068v22.052H423.7v-22.476c0-4.17-2.121-6.644-5.725-6.644-3.464,0-6.008,2.615-6.008,7v22.123H402.21v-36.965h9.542v4.311c1.343-2.544,4.595-5.23,9.613-5.23,4.735,0,8.2,2.12,10.108,5.512,2.19-3.392,6.007-5.512,10.955-5.512,8.411,0,12.581,5.583,12.581,13.5Z",
    transform: "translate(-364.256 133.604)",
    fill: "#f5f7fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(0.676 55.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M350.695-56.674a.483.483,0,0,1-.351.142.464.464,0,0,1-.342-.142.464.464,0,0,1-.141-.34v-3.714a.458.458,0,0,1,.145-.341.486.486,0,0,1,.351-.142.466.466,0,0,1,.342.142.465.465,0,0,1,.141.341v3.714A.456.456,0,0,1,350.695-56.674Z",
    transform: "translate(-349.861 61.212)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M355.477-56.164a.426.426,0,0,1-.313.127.419.419,0,0,1-.307-.127.419.419,0,0,1-.127-.307V-58.09a.6.6,0,0,0-.165-.486.688.688,0,0,0-.448-.134.825.825,0,0,0-.245.034.99.99,0,0,0-.21.09.976.976,0,0,0-.172.123.946.946,0,0,0-.13.145v1.846a.417.417,0,0,1-.128.307.426.426,0,0,1-.313.127.417.417,0,0,1-.306-.127.417.417,0,0,1-.128-.307V-59.02a.407.407,0,0,1,.128-.3.439.439,0,0,1,.32-.124.413.413,0,0,1,.3.124.414.414,0,0,1,.125.3v.048a1.511,1.511,0,0,1,.2-.189,1.276,1.276,0,0,1,.262-.165,1.638,1.638,0,0,1,.323-.117,1.547,1.547,0,0,1,.382-.045,1.067,1.067,0,0,1,.817.286,1.1,1.1,0,0,1,.265.775v1.957A.419.419,0,0,1,355.477-56.164Z",
    transform: "translate(-350.616 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M359.728-56.746a.392.392,0,0,1-.031.155.316.316,0,0,1-.108.127.565.565,0,0,1-.214.086,1.6,1.6,0,0,1-.351.031.966.966,0,0,1-.7-.231.9.9,0,0,1-.239-.679v-1.737h-.214a.361.361,0,0,1-.269-.114.387.387,0,0,1-.11-.278.36.36,0,0,1,.11-.262.368.368,0,0,1,.269-.11h.214v-.516a.418.418,0,0,1,.127-.307.427.427,0,0,1,.318-.128.415.415,0,0,1,.3.128.42.42,0,0,1,.126.307v.516h.345a.356.356,0,0,1,.262.113.383.383,0,0,1,.11.273.366.366,0,0,1-.11.268.358.358,0,0,1-.262.11h-.345v1.5a.346.346,0,0,0,.1.282.316.316,0,0,0,.2.083h.075a.366.366,0,0,1,.286.11A.384.384,0,0,1,359.728-56.746Z",
    transform: "translate(-352.059 61.067)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M364.434-57.863a.388.388,0,0,1-.117.28.389.389,0,0,1-.289.12h-2.054a.92.92,0,0,0,.093.3.8.8,0,0,0,.193.244.955.955,0,0,0,.289.166,1.124,1.124,0,0,0,.382.062,1.416,1.416,0,0,0,.314-.041,1.4,1.4,0,0,0,.334-.125.386.386,0,0,1,.172-.041.394.394,0,0,1,.255.1.313.313,0,0,1,.117.255.287.287,0,0,1-.152.262,1.839,1.839,0,0,1-.541.221,2.611,2.611,0,0,1-.6.068,1.981,1.981,0,0,1-.706-.124,1.661,1.661,0,0,1-.565-.352,1.612,1.612,0,0,1-.372-.551,1.882,1.882,0,0,1-.135-.724,1.826,1.826,0,0,1,.127-.679,1.69,1.69,0,0,1,.355-.555,1.692,1.692,0,0,1,.545-.372,1.722,1.722,0,0,1,.7-.137,1.707,1.707,0,0,1,.528.079,1.59,1.59,0,0,1,.444.224,1.525,1.525,0,0,1,.348.355,1.921,1.921,0,0,1,.238.465c.023.079.044.161.066.249A1.1,1.1,0,0,1,364.434-57.863Zm-.833-.192a.865.865,0,0,0-.056-.249.717.717,0,0,0-.145-.238.779.779,0,0,0-.251-.179.869.869,0,0,0-.37-.072.842.842,0,0,0-.355.068.769.769,0,0,0-.245.175.862.862,0,0,0-.151.238.92.92,0,0,0-.069.256Z",
    transform: "translate(-353.084 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M369.786-56.305a1.653,1.653,0,0,1-.164.782,1.329,1.329,0,0,1-.424.482,1.639,1.639,0,0,1-.577.245,2.971,2.971,0,0,1-.627.069,3.342,3.342,0,0,1-.344-.021,2.792,2.792,0,0,1-.379-.068,1.62,1.62,0,0,1-.338-.127.578.578,0,0,1-.227-.2.351.351,0,0,1-.055-.19.34.34,0,0,1,.11-.261.36.36,0,0,1,.255-.1.4.4,0,0,1,.187.048,1.283,1.283,0,0,0,.375.159,1.747,1.747,0,0,0,.417.048,1.426,1.426,0,0,0,.321-.038.821.821,0,0,0,.3-.137.7.7,0,0,0,.216-.261.906.906,0,0,0,.083-.412v-.338a1.481,1.481,0,0,1-.46.386,1.193,1.193,0,0,1-.57.138,1.518,1.518,0,0,1-.58-.11,1.282,1.282,0,0,1-.466-.324,1.524,1.524,0,0,1-.311-.531,2.164,2.164,0,0,1-.114-.73,2.206,2.206,0,0,1,.11-.724,1.534,1.534,0,0,1,.308-.534,1.282,1.282,0,0,1,.466-.328,1.552,1.552,0,0,1,.588-.11,1.281,1.281,0,0,1,.566.127,1.337,1.337,0,0,1,.464.382v-.034a.421.421,0,0,1,.126-.307.428.428,0,0,1,.318-.127.41.41,0,0,1,.3.127.421.421,0,0,1,.127.307Zm-.875-.951v-1.075a.711.711,0,0,0-.139-.152,1.04,1.04,0,0,0-.184-.121.973.973,0,0,0-.211-.079.907.907,0,0,0-.221-.027.9.9,0,0,0-.342.062.707.707,0,0,0-.266.182.861.861,0,0,0-.173.29,1.1,1.1,0,0,0-.063.382,1.107,1.107,0,0,0,.063.382.864.864,0,0,0,.173.289.715.715,0,0,0,.266.182.9.9,0,0,0,.342.063.943.943,0,0,0,.221-.028.973.973,0,0,0,.211-.079,1.038,1.038,0,0,0,.184-.12A.728.728,0,0,0,368.911-57.256Z",
    transform: "translate(-354.625 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M374.348-59.059a.4.4,0,0,1-.12.31.561.561,0,0,1-.3.138,1.369,1.369,0,0,0-.382.11.754.754,0,0,0-.3.241v1.805a.422.422,0,0,1-.125.307.406.406,0,0,1-.3.127H372.8a.42.42,0,0,1-.307-.127.416.416,0,0,1-.127-.307V-59a.406.406,0,0,1,.127-.3.442.442,0,0,1,.32-.124.411.411,0,0,1,.3.124.412.412,0,0,1,.125.3v.069q.062-.082.135-.169a.984.984,0,0,1,.162-.155.889.889,0,0,1,.193-.113.562.562,0,0,1,.227-.046.377.377,0,0,1,.29.1A.357.357,0,0,1,374.348-59.059Z",
    transform: "translate(-356.341 60.699)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M378.64-56.471a.421.421,0,0,1-.124.307.406.406,0,0,1-.3.127h-.069a.359.359,0,0,1-.268-.114.376.376,0,0,1-.11-.271,1.168,1.168,0,0,1-.448.313,1.568,1.568,0,0,1-.607.114,1.289,1.289,0,0,1-.407-.068,1.2,1.2,0,0,1-.372-.2,1.047,1.047,0,0,1-.272-.342,1.048,1.048,0,0,1-.108-.49,1.065,1.065,0,0,1,.108-.5.977.977,0,0,1,.272-.335,1.087,1.087,0,0,1,.372-.187,1.482,1.482,0,0,1,.407-.059,1.743,1.743,0,0,1,.61.1,1.027,1.027,0,0,1,.444.307v-.451a.491.491,0,0,0-.2-.409.854.854,0,0,0-.531-.152,1.569,1.569,0,0,0-.386.048,1.139,1.139,0,0,0-.358.166.318.318,0,0,1-.159.048.346.346,0,0,1-.224-.09.306.306,0,0,1-.106-.246.338.338,0,0,1,.048-.172.623.623,0,0,1,.241-.211,1.775,1.775,0,0,1,.362-.144,3.11,3.11,0,0,1,.393-.082,2.58,2.58,0,0,1,.341-.027,2.355,2.355,0,0,1,.544.062,1.287,1.287,0,0,1,.465.21,1.054,1.054,0,0,1,.324.39,1.323,1.323,0,0,1,.12.6Zm-.874-.406v-.414a.669.669,0,0,0-.3-.221,1.115,1.115,0,0,0-.405-.073.746.746,0,0,0-.446.131.433.433,0,0,0-.184.375.417.417,0,0,0,.184.363.759.759,0,0,0,.446.128,1.145,1.145,0,0,0,.405-.072A.679.679,0,0,0,377.766-56.877Z",
    transform: "translate(-357.258 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M382.75-56.746a.393.393,0,0,1-.031.155.308.308,0,0,1-.107.127.57.57,0,0,1-.214.086,1.6,1.6,0,0,1-.351.031.969.969,0,0,1-.7-.231.9.9,0,0,1-.239-.679v-1.737H380.9a.358.358,0,0,1-.268-.114.385.385,0,0,1-.11-.278.358.358,0,0,1,.11-.262.366.366,0,0,1,.268-.11h.214v-.516a.421.421,0,0,1,.127-.307.428.428,0,0,1,.318-.128.414.414,0,0,1,.3.128.421.421,0,0,1,.127.307v.516h.344a.353.353,0,0,1,.262.113.38.38,0,0,1,.11.273.364.364,0,0,1-.11.268.356.356,0,0,1-.262.11h-.344v1.5a.348.348,0,0,0,.1.282.318.318,0,0,0,.2.083h.075a.363.363,0,0,1,.286.11A.384.384,0,0,1,382.75-56.746Z",
    transform: "translate(-358.687 61.067)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M387.456-57.863a.391.391,0,0,1-.118.28.389.389,0,0,1-.289.12H385a.889.889,0,0,0,.093.3.792.792,0,0,0,.192.244.962.962,0,0,0,.289.166,1.129,1.129,0,0,0,.383.062,1.41,1.41,0,0,0,.313-.041,1.422,1.422,0,0,0,.335-.125.385.385,0,0,1,.172-.041.391.391,0,0,1,.254.1.311.311,0,0,1,.117.255.288.288,0,0,1-.151.262,1.855,1.855,0,0,1-.541.221,2.621,2.621,0,0,1-.6.068,1.974,1.974,0,0,1-.706-.124,1.648,1.648,0,0,1-.565-.352,1.6,1.6,0,0,1-.372-.551,1.882,1.882,0,0,1-.134-.724,1.825,1.825,0,0,1,.127-.679,1.713,1.713,0,0,1,.355-.555,1.691,1.691,0,0,1,.545-.372,1.723,1.723,0,0,1,.7-.137,1.714,1.714,0,0,1,.528.079,1.611,1.611,0,0,1,.444.224,1.521,1.521,0,0,1,.348.355,1.894,1.894,0,0,1,.238.465c.023.079.045.161.066.249A1.1,1.1,0,0,1,387.456-57.863Zm-.834-.192a.862.862,0,0,0-.056-.249.727.727,0,0,0-.145-.238.774.774,0,0,0-.251-.179.863.863,0,0,0-.369-.072.838.838,0,0,0-.355.068.77.77,0,0,0-.245.175.866.866,0,0,0-.152.238.921.921,0,0,0-.069.256Z",
    transform: "translate(-359.712 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M392.814-56.967a.42.42,0,0,1-.126.307.433.433,0,0,1-.318.127.412.412,0,0,1-.3-.127.418.418,0,0,1-.127-.307V-57a1.4,1.4,0,0,1-.464.38,1.253,1.253,0,0,1-.566.13,1.443,1.443,0,0,1-.587-.118,1.33,1.33,0,0,1-.466-.337,1.593,1.593,0,0,1-.311-.548,2.26,2.26,0,0,1-.114-.741,2.243,2.243,0,0,1,.111-.731,1.641,1.641,0,0,1,.307-.551,1.328,1.328,0,0,1,.47-.348,1.459,1.459,0,0,1,.591-.12,1.294,1.294,0,0,1,.563.127,1.328,1.328,0,0,1,.466.382v-1.3a.421.421,0,0,1,.127-.307.429.429,0,0,1,.318-.127.416.416,0,0,1,.3.127.422.422,0,0,1,.126.307Zm-.875-.682v-1.178a.826.826,0,0,0-.325-.273.976.976,0,0,0-.437-.106.839.839,0,0,0-.342.068.731.731,0,0,0-.266.2.931.931,0,0,0-.173.31,1.18,1.18,0,0,0-.063.393,1.18,1.18,0,0,0,.063.393.893.893,0,0,0,.173.306.738.738,0,0,0,.266.2.84.84,0,0,0,.342.069.968.968,0,0,0,.437-.107A.815.815,0,0,0,391.939-57.649Z",
    transform: "translate(-361.253 61.212)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M401.594-59.672a1.564,1.564,0,0,1-.086.538,1.324,1.324,0,0,1-.231.4,1.286,1.286,0,0,1-.324.276,1.249,1.249,0,0,1-.365.148l.633,1.075a.49.49,0,0,1,.063.234.493.493,0,0,1-.131.33.438.438,0,0,1-.35.152.465.465,0,0,1-.241-.066.517.517,0,0,1-.179-.182l-.783-1.427h-.715V-57a.456.456,0,0,1-.145.34.483.483,0,0,1-.351.142.463.463,0,0,1-.342-.142.464.464,0,0,1-.141-.34v-3.6a.532.532,0,0,1,.161-.389.531.531,0,0,1,.389-.162h1.6a1.778,1.778,0,0,1,.643.11,1.384,1.384,0,0,1,.485.31,1.36,1.36,0,0,1,.305.472A1.6,1.6,0,0,1,401.594-59.672Zm-1.682-.62h-1.027v1.24h1.027a.738.738,0,0,0,.493-.165.566.566,0,0,0,.2-.455.567.567,0,0,0-.2-.455A.738.738,0,0,0,399.912-60.292Z",
    transform: "translate(-363.693 61.195)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M406.888-57.863a.391.391,0,0,1-.117.28.391.391,0,0,1-.29.12h-2.053a.9.9,0,0,0,.093.3.8.8,0,0,0,.193.244.954.954,0,0,0,.289.166,1.124,1.124,0,0,0,.382.062,1.411,1.411,0,0,0,.314-.041,1.406,1.406,0,0,0,.334-.125.391.391,0,0,1,.173-.041.392.392,0,0,1,.254.1.313.313,0,0,1,.117.255.287.287,0,0,1-.152.262,1.838,1.838,0,0,1-.541.221,2.611,2.611,0,0,1-.6.068,1.98,1.98,0,0,1-.706-.124,1.661,1.661,0,0,1-.565-.352,1.613,1.613,0,0,1-.372-.551,1.883,1.883,0,0,1-.135-.724,1.825,1.825,0,0,1,.127-.679,1.688,1.688,0,0,1,.355-.555,1.692,1.692,0,0,1,.545-.372,1.722,1.722,0,0,1,.695-.137,1.715,1.715,0,0,1,.528.079,1.61,1.61,0,0,1,.444.224,1.538,1.538,0,0,1,.348.355,1.9,1.9,0,0,1,.238.465c.023.079.044.161.066.249A1.1,1.1,0,0,1,406.888-57.863Zm-.834-.192A.891.891,0,0,0,406-58.3a.731.731,0,0,0-.145-.238.771.771,0,0,0-.251-.179.867.867,0,0,0-.37-.072.842.842,0,0,0-.355.068.768.768,0,0,0-.244.175.849.849,0,0,0-.152.238.919.919,0,0,0-.069.256Z",
    transform: "translate(-365.306 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M411.993-58.987a.374.374,0,0,1-.027.152l-.971,2.4a.663.663,0,0,1-.241.3.628.628,0,0,1-.365.114h-.013a.643.643,0,0,1-.369-.114.646.646,0,0,1-.244-.3l-.972-2.4a.421.421,0,0,1-.034-.159.429.429,0,0,1,.123-.293.425.425,0,0,1,.324-.135.412.412,0,0,1,.238.073.409.409,0,0,1,.155.2l.779,2.087.779-2.08a.4.4,0,0,1,.157-.2.433.433,0,0,1,.241-.073.411.411,0,0,1,.32.135A.435.435,0,0,1,411.993-58.987Z",
    transform: "translate(-366.816 60.697)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M417.2-57.863a.391.391,0,0,1-.117.28.389.389,0,0,1-.289.12h-2.054a.886.886,0,0,0,.093.3.793.793,0,0,0,.192.244.959.959,0,0,0,.29.166,1.121,1.121,0,0,0,.382.062,1.405,1.405,0,0,0,.313-.041,1.424,1.424,0,0,0,.335-.125.385.385,0,0,1,.172-.041.391.391,0,0,1,.254.1.311.311,0,0,1,.117.255.288.288,0,0,1-.151.262,1.854,1.854,0,0,1-.541.221,2.622,2.622,0,0,1-.6.068,1.975,1.975,0,0,1-.706-.124,1.648,1.648,0,0,1-.565-.352,1.605,1.605,0,0,1-.372-.551,1.882,1.882,0,0,1-.134-.724,1.812,1.812,0,0,1,.128-.679,1.688,1.688,0,0,1,.355-.555,1.68,1.68,0,0,1,.544-.372,1.724,1.724,0,0,1,.7-.137,1.714,1.714,0,0,1,.528.079,1.6,1.6,0,0,1,.444.224,1.508,1.508,0,0,1,.347.355,1.9,1.9,0,0,1,.238.465c.023.079.045.161.065.249A1.1,1.1,0,0,1,417.2-57.863Zm-.834-.192a.867.867,0,0,0-.056-.249.729.729,0,0,0-.145-.238.775.775,0,0,0-.251-.179.863.863,0,0,0-.369-.072.838.838,0,0,0-.355.068.771.771,0,0,0-.245.175.866.866,0,0,0-.152.238.924.924,0,0,0-.069.256Z",
    transform: "translate(-368.276 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M422.471-56.164a.426.426,0,0,1-.313.127.419.419,0,0,1-.307-.127.419.419,0,0,1-.128-.307V-58.09a.6.6,0,0,0-.165-.486.688.688,0,0,0-.448-.134.825.825,0,0,0-.245.034.993.993,0,0,0-.21.09,1,1,0,0,0-.172.123.942.942,0,0,0-.13.145v1.846a.417.417,0,0,1-.128.307.426.426,0,0,1-.313.127.419.419,0,0,1-.307-.127.417.417,0,0,1-.128-.307V-59.02a.407.407,0,0,1,.128-.3.439.439,0,0,1,.32-.124.413.413,0,0,1,.3.124.414.414,0,0,1,.125.3v.048a1.559,1.559,0,0,1,.2-.189,1.313,1.313,0,0,1,.262-.165,1.637,1.637,0,0,1,.323-.117,1.547,1.547,0,0,1,.382-.045,1.067,1.067,0,0,1,.818.286,1.1,1.1,0,0,1,.265.775v1.957A.419.419,0,0,1,422.471-56.164Z",
    transform: "translate(-369.903 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M428.074-56.147a.428.428,0,0,1-.314.127.417.417,0,0,1-.306-.127.419.419,0,0,1-.127-.307v-.027a1.641,1.641,0,0,1-.465.348,1.488,1.488,0,0,1-.707.155,1.069,1.069,0,0,1-.813-.278,1.08,1.08,0,0,1-.262-.768V-59a.406.406,0,0,1,.128-.3.442.442,0,0,1,.32-.124.411.411,0,0,1,.3.124.412.412,0,0,1,.125.3v1.633a.81.81,0,0,0,.045.289.473.473,0,0,0,.125.19.47.47,0,0,0,.192.1.986.986,0,0,0,.252.031.842.842,0,0,0,.447-.117,1.183,1.183,0,0,0,.31-.262V-59a.409.409,0,0,1,.127-.3.441.441,0,0,1,.321-.124.414.414,0,0,1,.3.124.414.414,0,0,1,.124.3v2.549A.419.419,0,0,1,428.074-56.147Z",
    transform: "translate(-371.516 60.699)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M433.76-57.863a.391.391,0,0,1-.117.28.391.391,0,0,1-.29.12H431.3a.9.9,0,0,0,.092.3.805.805,0,0,0,.193.244.954.954,0,0,0,.289.166,1.125,1.125,0,0,0,.382.062,1.411,1.411,0,0,0,.314-.041,1.406,1.406,0,0,0,.334-.125.391.391,0,0,1,.173-.041.391.391,0,0,1,.254.1.313.313,0,0,1,.117.255.287.287,0,0,1-.152.262,1.839,1.839,0,0,1-.541.221,2.61,2.61,0,0,1-.6.068,1.981,1.981,0,0,1-.707-.124,1.661,1.661,0,0,1-.565-.352,1.612,1.612,0,0,1-.372-.551,1.882,1.882,0,0,1-.135-.724,1.824,1.824,0,0,1,.128-.679,1.688,1.688,0,0,1,.355-.555,1.692,1.692,0,0,1,.545-.372,1.722,1.722,0,0,1,.695-.137,1.715,1.715,0,0,1,.528.079,1.611,1.611,0,0,1,.444.224,1.537,1.537,0,0,1,.347.355,1.9,1.9,0,0,1,.238.465c.023.079.044.161.066.249A1.106,1.106,0,0,1,433.76-57.863Zm-.834-.192a.868.868,0,0,0-.056-.249.74.74,0,0,0-.145-.238.782.782,0,0,0-.251-.179.867.867,0,0,0-.37-.072.843.843,0,0,0-.355.068.767.767,0,0,0-.244.175.848.848,0,0,0-.152.238.92.92,0,0,0-.069.256Z",
    transform: "translate(-373.043 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M443.378-56.667a.486.486,0,0,1-.354.145.478.478,0,0,1-.348-.145.468.468,0,0,1-.145-.345v-2.77L441.293-56.7a.305.305,0,0,1-.107.127.279.279,0,0,1-.169.052.252.252,0,0,1-.157-.052.312.312,0,0,1-.1-.127l-1.238-3.081V-57a.459.459,0,0,1-.145.34.483.483,0,0,1-.352.142.463.463,0,0,1-.341-.142.463.463,0,0,1-.141-.34v-3.6A.532.532,0,0,1,438.7-61a.531.531,0,0,1,.39-.162,1.445,1.445,0,0,1,.607.056.64.64,0,0,1,.392.393l.937,2.329.937-2.329a.716.716,0,0,1,.262-.324.7.7,0,0,1,.407-.125,1.125,1.125,0,0,1,.324-.006.88.88,0,0,1,.286.085.525.525,0,0,1,.2.183.516.516,0,0,1,.076.289v3.6A.471.471,0,0,1,443.378-56.667Z",
    transform: "translate(-375.392 61.201)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M449.572-56.471a.424.424,0,0,1-.124.307.408.408,0,0,1-.3.127h-.068a.356.356,0,0,1-.268-.114.374.374,0,0,1-.111-.271,1.171,1.171,0,0,1-.447.313,1.569,1.569,0,0,1-.607.114,1.285,1.285,0,0,1-.407-.068,1.2,1.2,0,0,1-.372-.2,1.064,1.064,0,0,1-.272-.342,1.057,1.057,0,0,1-.107-.49,1.074,1.074,0,0,1,.107-.5.992.992,0,0,1,.272-.335,1.091,1.091,0,0,1,.372-.187,1.477,1.477,0,0,1,.407-.059,1.736,1.736,0,0,1,.61.1,1.027,1.027,0,0,1,.444.307v-.451a.489.489,0,0,0-.2-.409.85.85,0,0,0-.53-.152,1.57,1.57,0,0,0-.386.048,1.137,1.137,0,0,0-.359.166.313.313,0,0,1-.158.048.346.346,0,0,1-.224-.09.3.3,0,0,1-.106-.246.338.338,0,0,1,.048-.172.619.619,0,0,1,.241-.211,1.758,1.758,0,0,1,.362-.144,3.1,3.1,0,0,1,.392-.082,2.589,2.589,0,0,1,.342-.027,2.355,2.355,0,0,1,.544.062,1.287,1.287,0,0,1,.465.21,1.061,1.061,0,0,1,.324.39,1.332,1.332,0,0,1,.12.6Zm-.875-.406v-.414a.668.668,0,0,0-.3-.221,1.119,1.119,0,0,0-.406-.073.746.746,0,0,0-.446.131.433.433,0,0,0-.184.375.417.417,0,0,0,.184.363.759.759,0,0,0,.446.128,1.149,1.149,0,0,0,.406-.072A.677.677,0,0,0,448.7-56.877Z",
    transform: "translate(-377.679 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M455.034-56.164a.428.428,0,0,1-.314.127.417.417,0,0,1-.306-.127.419.419,0,0,1-.128-.307V-58.09a.6.6,0,0,0-.165-.486.691.691,0,0,0-.448-.134.821.821,0,0,0-.245.034.976.976,0,0,0-.21.09.947.947,0,0,0-.172.123.952.952,0,0,0-.131.145v1.846a.414.414,0,0,1-.128.307.425.425,0,0,1-.313.127.42.42,0,0,1-.307-.127.416.416,0,0,1-.127-.307V-59.02a.406.406,0,0,1,.127-.3.441.441,0,0,1,.32-.124.411.411,0,0,1,.3.124.412.412,0,0,1,.125.3v.048a1.523,1.523,0,0,1,.2-.189,1.274,1.274,0,0,1,.262-.165,1.621,1.621,0,0,1,.323-.117,1.547,1.547,0,0,1,.382-.045,1.065,1.065,0,0,1,.817.286,1.1,1.1,0,0,1,.265.775v1.957A.418.418,0,0,1,455.034-56.164Z",
    transform: "translate(-379.278 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M460.43-56.471a.423.423,0,0,1-.123.307.409.409,0,0,1-.3.127h-.069a.358.358,0,0,1-.268-.114.376.376,0,0,1-.11-.271,1.168,1.168,0,0,1-.448.313A1.568,1.568,0,0,1,458.5-56a1.289,1.289,0,0,1-.407-.068,1.2,1.2,0,0,1-.372-.2,1.048,1.048,0,0,1-.272-.342,1.049,1.049,0,0,1-.108-.49,1.066,1.066,0,0,1,.108-.5.978.978,0,0,1,.272-.335,1.088,1.088,0,0,1,.372-.187,1.482,1.482,0,0,1,.407-.059,1.743,1.743,0,0,1,.61.1,1.028,1.028,0,0,1,.444.307v-.451a.491.491,0,0,0-.2-.409.854.854,0,0,0-.531-.152,1.57,1.57,0,0,0-.386.048,1.139,1.139,0,0,0-.358.166.318.318,0,0,1-.159.048.348.348,0,0,1-.224-.09.306.306,0,0,1-.106-.246.338.338,0,0,1,.048-.172.624.624,0,0,1,.241-.211,1.793,1.793,0,0,1,.362-.144,3.114,3.114,0,0,1,.393-.082,2.581,2.581,0,0,1,.341-.027,2.356,2.356,0,0,1,.544.062,1.287,1.287,0,0,1,.465.21,1.055,1.055,0,0,1,.324.39,1.323,1.323,0,0,1,.12.6Zm-.874-.406v-.414a.67.67,0,0,0-.3-.221,1.115,1.115,0,0,0-.405-.073.746.746,0,0,0-.446.131.433.433,0,0,0-.184.375.417.417,0,0,0,.184.363.759.759,0,0,0,.446.128,1.145,1.145,0,0,0,.405-.072A.68.68,0,0,0,459.556-56.877Z",
    transform: "translate(-380.805 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M465.974-56.305a1.653,1.653,0,0,1-.164.782,1.322,1.322,0,0,1-.424.482,1.636,1.636,0,0,1-.576.245,2.97,2.97,0,0,1-.627.069,3.346,3.346,0,0,1-.345-.021,2.812,2.812,0,0,1-.379-.068,1.6,1.6,0,0,1-.337-.127.58.58,0,0,1-.228-.2.357.357,0,0,1-.055-.19.343.343,0,0,1,.11-.261.36.36,0,0,1,.256-.1.4.4,0,0,1,.187.048,1.275,1.275,0,0,0,.375.159,1.748,1.748,0,0,0,.417.048,1.421,1.421,0,0,0,.32-.038.82.82,0,0,0,.3-.137.7.7,0,0,0,.217-.261.907.907,0,0,0,.083-.412v-.338a1.466,1.466,0,0,1-.46.386,1.19,1.19,0,0,1-.569.138,1.522,1.522,0,0,1-.581-.11,1.288,1.288,0,0,1-.466-.324,1.534,1.534,0,0,1-.311-.531,2.163,2.163,0,0,1-.114-.73,2.187,2.187,0,0,1,.111-.724,1.531,1.531,0,0,1,.307-.534,1.3,1.3,0,0,1,.466-.328,1.556,1.556,0,0,1,.588-.11,1.283,1.283,0,0,1,.566.127,1.33,1.33,0,0,1,.463.382v-.034a.421.421,0,0,1,.127-.307.427.427,0,0,1,.318-.127.411.411,0,0,1,.3.127.42.42,0,0,1,.126.307Zm-.875-.951v-1.075a.707.707,0,0,0-.138-.152,1.039,1.039,0,0,0-.184-.121,1,1,0,0,0-.211-.079.912.912,0,0,0-.222-.027.9.9,0,0,0-.342.062.7.7,0,0,0-.266.182.837.837,0,0,0-.173.29,1.087,1.087,0,0,0-.063.382,1.09,1.09,0,0,0,.063.382.841.841,0,0,0,.173.289.7.7,0,0,0,.266.182.9.9,0,0,0,.342.063.949.949,0,0,0,.222-.028,1,1,0,0,0,.211-.079,1.037,1.037,0,0,0,.184-.12A.723.723,0,0,0,465.1-57.256Z",
    transform: "translate(-382.317 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M471.635-57.863a.391.391,0,0,1-.118.28.391.391,0,0,1-.29.12h-2.053a.9.9,0,0,0,.093.3.8.8,0,0,0,.193.244.955.955,0,0,0,.289.166,1.125,1.125,0,0,0,.382.062,1.411,1.411,0,0,0,.314-.041,1.407,1.407,0,0,0,.334-.125.39.39,0,0,1,.173-.041.391.391,0,0,1,.254.1.313.313,0,0,1,.117.255.287.287,0,0,1-.152.262,1.838,1.838,0,0,1-.541.221,2.61,2.61,0,0,1-.6.068,1.981,1.981,0,0,1-.707-.124,1.661,1.661,0,0,1-.565-.352,1.612,1.612,0,0,1-.372-.551,1.882,1.882,0,0,1-.135-.724,1.823,1.823,0,0,1,.127-.679,1.689,1.689,0,0,1,.355-.555,1.691,1.691,0,0,1,.545-.372,1.723,1.723,0,0,1,.7-.137,1.715,1.715,0,0,1,.528.079,1.609,1.609,0,0,1,.444.224,1.536,1.536,0,0,1,.347.355,1.894,1.894,0,0,1,.238.465c.023.079.044.161.066.249A1.1,1.1,0,0,1,471.635-57.863Zm-.834-.192a.867.867,0,0,0-.056-.249.731.731,0,0,0-.145-.238.772.772,0,0,0-.251-.179.867.867,0,0,0-.37-.072.843.843,0,0,0-.355.068.767.767,0,0,0-.244.175.849.849,0,0,0-.152.238.92.92,0,0,0-.069.256Z",
    transform: "translate(-383.947 60.716)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M475.888-59.059a.4.4,0,0,1-.12.31.561.561,0,0,1-.3.138,1.368,1.368,0,0,0-.382.11.754.754,0,0,0-.3.241v1.805a.422.422,0,0,1-.125.307.406.406,0,0,1-.3.127h-.014a.42.42,0,0,1-.307-.127.416.416,0,0,1-.127-.307V-59a.406.406,0,0,1,.127-.3.442.442,0,0,1,.32-.124.411.411,0,0,1,.3.124.411.411,0,0,1,.125.3v.069q.062-.082.135-.169a.982.982,0,0,1,.162-.155.889.889,0,0,1,.193-.113.565.565,0,0,1,.227-.046.377.377,0,0,1,.29.1A.358.358,0,0,1,475.888-59.059Z",
    transform: "translate(-385.574 60.699)",
    fill: "#f5f7fa"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4035",
    "data-name": "Rectangle 4035",
    width: 195.646,
    height: 10.739,
    rx: 1.743,
    transform: "translate(-24.129 406.324) rotate(-7.921)",
    fill: "rgba(245,247,250,0.53)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 1,
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginleftsvg);
export default __webpack_public_path__ + "static/media/login left svg.f2712ef7ac8ee55edfef5bde4572832a.svg";
export { ForwardRef as ReactComponent };